import React from 'react';
import dynamic from 'next/dynamic';

import { ProductPageHeader } from 'src/components/headers/ProductPageHeader';
import Features from 'src/components/features';
import Showcase from 'src/components/showcase';
import Quote from 'src/components/quote';
import FooterExtension from 'src/components/footer-extension';

import { Locales } from 'src/lib/constants';

import {
  metaData,
  productHeaderData,
  featuresData,
  interactiveData,
  showcaseData,
  quoteData,
  footerExtensionData,
} from 'src/store/en-gb/products/assets';

import { ProductPageTemplate } from 'src/templates';

const InteractiveData = dynamic(
  () => {
    return import('src/components/Surfaces/InteractiveData/InteractiveData');
  },
  {
    ssr: false,
  },
);

const UKProductAssets = ({ locale = Locales.EN_GB }) => {
  return (
    <ProductPageTemplate
      fields={{ components: [], ...metaData }}
      locale={locale}
    >
      <ProductPageHeader {...productHeaderData} />
      <Features {...featuresData} />
      <InteractiveData {...interactiveData} />
      <Showcase {...showcaseData} />
      <Quote {...quoteData} />
      <FooterExtension {...footerExtensionData} />
    </ProductPageTemplate>
  );
};

export default UKProductAssets;
